import * as React from "react";
import type { SVGProps } from "react";
const SvgStopwatch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M12.974 14.417a1.391 1.391 0 1 1-2.783 0 1.391 1.391 0 0 1 2.783 0"
    />
    <path
      fill="#000"
      d="M19.803 2.806a1 1 0 1 0-1.414 1.414l.707-.707zm1.09 3.919a1 1 0 1 0 1.414-1.415l-.707.707zm-8.31 2.962a1 1 0 1 0-2 0h2m-2 3.617a1 1 0 1 0 2 0h-2M8.8.287a1 1 0 0 0 0 2v-2m5.287 2a1 1 0 1 0 0-2v2m3.467 3.858a1 1 0 0 0 1.414 1.414l-.707-.707zm2.794-1.38.707-.707zm-8.765 4.922h-1v3.617h2V9.687zM8.8 1.287v1h5.287v-2H8.8zm9.46 5.565.708.707 2.087-2.087-.707-.707-.707-.707-2.087 2.087zm2.505 6.678h-1a8.183 8.183 0 0 1-8.182 8.183v2c5.623 0 10.182-4.559 10.182-10.183zm-9.182 9.183v-1A8.183 8.183 0 0 1 3.4 13.53h-2c0 5.624 4.559 10.183 10.183 10.183zM2.4 13.53h1a8.183 8.183 0 0 1 8.183-8.182v-2C5.959 3.348 1.4 7.907 1.4 13.53zm9.183-9.182v1a8.183 8.183 0 0 1 8.182 8.182h2c0-5.623-4.559-10.182-10.182-10.182zm1.39 10.07h-1a.39.39 0 0 1-.39.39v2c1.32 0 2.39-1.07 2.39-2.39zm-1.39 1.39v-1a.39.39 0 0 1-.392-.39h-2c0 1.32 1.071 2.39 2.392 2.39zm-1.392-1.39h1c0-.217.175-.392.392-.392v-2a2.39 2.39 0 0 0-2.392 2.391zm1.392-1.392v1c.216 0 .39.175.39.391h2c0-1.32-1.07-2.39-2.39-2.39zm7.513-9.513-.707.707 1.252 1.252.707-.707.707-.707-1.252-1.252zm1.252 1.252-.707.707 1.252 1.252.707-.707.707-.707-1.252-1.252z"
    />
  </svg>
);
export default SvgStopwatch02;
